import(/* webpackMode: "eager" */ "/vercel/path0/src/app/contato/page.tsx");
